import { store } from '@betacrew/jars-flux'
import { put, all, takeLatest, takeEvery } from 'redux-saga/effects';
import { componentKey, setBoiGridRecords, setLoadingState, setPaginationState, setPayersList, setReferenceNumberOnFormSubmissionWithoutPayment, setReloadBoiGridRecords, setShowSubmitFormConfirmationPopupOnSubscription } from './ManageBoiSlice';
import BoiDataService from '../../../services/BoiDataService';
import { addNotifications } from '../toaster/ToasterPortalSlice';
import General from '../../../libs/utility/General';
import PayerDataService from '../../../services/PayerDataService';
import { MANAGE_BOI_LOADING_STATES } from './constants';
import { TOASTER_VARIANT } from '../../components/toast/constants';

export const { getBoiForms, getPayersList, viewPDF, deleteBoiForm, boiLifeTimePayment, resubmitBoi } = {
	getBoiForms: (payload) => {
		return {
			type: "BOI/GET_BOI_FORMS",
			payload: payload
		}
	},
    getPayersList: (payload) => {
		return {
			type: "BOI/GET_PAYERS",
			payload: payload
		}
	},
    viewPDF: (payload) => {
        return {
            type: "FILE_BOI/VIEW_PDF",
            payload
        }
    },
    deleteBoiForm: (payload) => {
        return {
            type: "FILE_BOI/DELETE_FORM",
            payload
        }
    },
    boiLifeTimePayment: (payload) => {
        return {
            type: "FILE_BOI/LIFE_TIME_PAYMENT",
            payload
        }
    },
    resubmitBoi: (payload) => {
        return {
            type: "FILE_BOI/RESUBMIT_BOI",
            payload
        }
    },
}

function* getBoiFormsAsync(action){
    try {
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.GRID_LOADING }))

        const { PageNumber, PageSize, status, payerDetailId = ''} = action.payload;

        const params = {
            PageNumber: PageNumber || 1,
            PageSize: PageSize || 10,
            status: status || "Submitted",
            payerDetailId: payerDetailId,
        }

        const response = yield BoiDataService.getBoiForms(params);

        const { Message, Status } = response?.data;
        const Data  = General.extractDataFromResponseData(response.data)

        if (Status && Data) {
            
            yield put(setBoiGridRecords(Data));
            yield put(setPaginationState({ totalRecords: General.extractPaginationTotalFromResponse(response.data) }))

        } else {
            yield put(setBoiGridRecords([]));
            yield put(addNotifications({ heading: "Error",  message: Message}));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(setBoiGridRecords([]));
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.GRID_READY }))
    }
}

function* getPayersListAsync(action){
    try {
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.PAYERS_LIST_LOADING }))

        const response = yield PayerDataService.getPayersList();

        const { Data, Message, Status } = response?.data;

        if (Status) {
            if(Data.length > 0){
                General.addOptionAndValueKeys(Data, "LastName", "PayerDetailId")
                yield put(setPayersList(Data));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.PAYERS_LIST_READY }))
    }
}

function* viewPDFAsync(action) {

    try {
        const { formRecordId } = action.payload
        yield put(setLoadingState({ state: `${MANAGE_BOI_LOADING_STATES.VIEW_PDF_LOADING}-${formRecordId}` }))

        const response = yield BoiDataService.viewPDF(formRecordId);

        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.openBase64FileInNewTab(Data.Base64, Data.Name);
        } else {
            yield put(addNotifications({ heading: "Failed to open a PDF", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.VIEW_PDF_READY }))
    }

}

function* deleteBoiFormAsync(action) {

    try {
        const { formRecordId } = action.payload
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.GRID_LOADING }))

        const response = yield BoiDataService.deleteBoiForm({formRecordId: formRecordId});

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setReloadBoiGridRecords(true));
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.GRID_READY }))
    }

}

function* boiLifeTimePaymentAsync(action) {

    try {
        const { formRecordId } = action.payload
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.GRID_LOADING }))

        const response = yield BoiDataService.boiLifeTimePayment({FormRecordId: formRecordId});

        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(setReferenceNumberOnFormSubmissionWithoutPayment(Data?.ReferenceId))
            yield put(setReloadBoiGridRecords(true));
            yield put(setShowSubmitFormConfirmationPopupOnSubscription(false));
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.GRID_READY }))
    }

}

function* resubmitBoiAsync(action) {

    try {
        const { referenceId } = action.payload
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.GRID_LOADING }))

        const response = yield BoiDataService.resubmitBoi({referenceId: referenceId});
        if (response && response.data) {
            const { Message, Status, Data } = response?.data;
    
            if (Status) {
                yield put(addNotifications({ heading: "Success", message: `${Message} Reference Id: ${Data}`, variant: TOASTER_VARIANT.SUCCESS  }));
                yield put(setReloadBoiGridRecords(true));
            } else {
                yield put(addNotifications({ heading: "Error", message: Message }));
            }
        }else{
            yield put(addNotifications({ heading: "Error", message: "Unexpected error occurred" }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error }));
    } finally {
        yield put(setLoadingState({ state: MANAGE_BOI_LOADING_STATES.GRID_READY }))
    }

}

function* rootSaga() {
	yield all([
		takeLatest(getBoiForms().type, getBoiFormsAsync),
		takeLatest(getPayersList().type, getPayersListAsync),
        takeLatest(viewPDF().type, viewPDFAsync),
        takeLatest(deleteBoiForm().type, deleteBoiFormAsync),
        takeLatest(boiLifeTimePayment().type, boiLifeTimePaymentAsync),
        takeLatest(resubmitBoi().type, resubmitBoiAsync),
	]);
}

store.sagaManager.addSaga(componentKey, rootSaga);